import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Box, Card, CardBody, CardHeader, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import { motion } from "framer-motion";

import { selectActiveProperties } from "../../redux/user/userSlice";

import AdministrationFees from "./AdministrationFees";
import BillingInformation from "./BillingInformation";
import FinancialStatus from "./FinancialStatus";
import PersonalInformation from "./PersonalInformation";

const MotionBox = motion(Box);

export default function Owner() {
	const { id } = useParams();
	const owner = useSelector(selectActiveProperties)?.find((p) => p.owner.id === id).owner;
	const properties = useSelector(selectActiveProperties).filter((p) => owner.properties.includes(p.id));
	const tabs = [
		{ title: "Personal Information", component: <PersonalInformation owner={owner} /> },
		{ title: "Financial Status", component: <FinancialStatus owner={owner} properties={properties} /> },
		{ title: "Billing Information", component: <BillingInformation owner={owner} properties={properties} /> },
		{ title: "Administration Fees", component: <AdministrationFees owner={owner} properties={properties} /> },
	];

	const bgColor = useColorModeValue("white", "gray.800");
	const borderColor = useColorModeValue("gray.200", "gray.700");
	const tabBg = useColorModeValue("gray.50", "gray.700");
	const activeTabBg = useColorModeValue("white", "gray.800");

	useEffect(() => {
		console.log("properties: ", properties);
		console.log("owner: ", owner);
	}, [owner, properties]);

	return (
		<MotionBox initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
			<Card boxShadow="sm" borderRadius="lg" bg={bgColor} borderWidth="1px" borderColor={borderColor}>
				<CardHeader fontSize="2xl" fontWeight="bold" pb={6} borderBottomWidth="1px" borderColor={borderColor}>
					Owner Details
				</CardHeader>
				<CardBody pt={6}>
					<Tabs variant="enclosed" isFitted isLazy colorScheme="blue">
						<TabList overflowX="auto" overflowY="hidden" borderBottomWidth="2px" borderColor={borderColor} mb={4}>
							{tabs.map((t, index) => (
								<Tab
									key={index}
									_selected={{
										bg: activeTabBg,
										borderColor: borderColor,
										borderBottomColor: activeTabBg,
										mb: "-2px",
										fontWeight: "semibold",
									}}
									py={3}
									bg={tabBg}
									borderRadius="md"
									borderTopRadius="md"
									mx={1}
									transition="all 0.2s"
									_hover={{ bg: activeTabBg }}
								>
									{t.title}
								</Tab>
							))}
						</TabList>
						<TabPanels>
							{tabs.map((t, index) => (
								<TabPanel key={index} px={0}>
									{t.component}
								</TabPanel>
							))}
						</TabPanels>
					</Tabs>
				</CardBody>
			</Card>
		</MotionBox>
	);
}
